import * as ko from 'knockout';
import { DONE } from '../../../helper';
import { IUpdateItemStateInput } from '../../../its-itembank-api.g';
import * as RICHTEXTHTML from '../../../richtext/html';
import { ServerConnection } from '../../../ui/RestAPI';
import { INIT, ItemDataModel, translate } from '../ItemDataModel';
import { ItemModel } from "../ItemModel";

function getData(item: INIT) {
    if (item.data.__typename === 'KosovoSingleChoiceText_QueryItemSessionData') {
        return item.data;
    }
    throw new Error();
}

type DATA = ReturnType<typeof getData>;
type ANSWER = DATA['sctAnswers'][0];

export class SingleChoiceTextData_Answer {
    constructor(private readonly model: SingleChoiceTextData, public readonly rawData: ANSWER) {
        this.id = rawData.id;
    }
    public readonly id: string;
    public readonly value = ko.pureComputed(() => RICHTEXTHTML.process({
        html: translate(this.rawData.text, {}),
        attachments: this.model.meta.attachments,
    }));
    public readonly isSelected = ko.pureComputed(() => this.id === this.model.selectedAnswer());
    public readonly isCorrectAnswer = ko.pureComputed(() => this.id === this.model.correctAnswer);
}

export class SingleChoiceTextData extends ItemDataModel {
    constructor(readonly meta: ItemModel, data: DATA) {
        super();
        const imgAtt = meta.getAttachment(data.sctImage?.id);
        this.imgUrl = ServerConnection.getDataUrl(imgAtt?.hrefResolved);
        this.imgAlt = imgAtt?.altText?.value ?? '';
        this.hasImage = !!this.imgUrl;
        this.correctAnswer = data.correctAnswer;
        this.headerText = translate(data.header, {});
        this.questionHTML = RICHTEXTHTML.process({
            html: translate(data.question, {}),
            attachments: this.meta.attachments,
        });
        this.answers = data.sctAnswers.map(a => new SingleChoiceTextData_Answer(this, a));
        this.fromJS(data);
    }
    public fromJS(data: DATA) {
        if (data.__typename !== 'KosovoSingleChoiceText_QueryItemSessionData') {
            throw new Error();
        }
        this.selectedAnswer(data.selectedAnswer);
    }
    public readonly questionHTML: string;
    public readonly answers: SingleChoiceTextData_Answer[];
    public readonly selectedAnswer = ko.observable<string>();
    public readonly correctAnswer: string;
    public readonly imgUrl: string;
    public readonly imgAlt: string;
    public readonly hasImage: boolean;
    public readonly headerText: string;
    public async setAnswer(answerId: string) {
        this.selectedAnswer(answerId);
    }

    public IsInteractionStarted() {
        return !!this.selectedAnswer();
    }
    public IsInteractionComplete() {
        return !!this.selectedAnswer();
    }
    public async reset() {
        this.selectedAnswer(undefined);
        return DONE;
    }
    public getItemState() {
        const retVal: IUpdateItemStateInput = {
            itemId: this.meta.itemId,
            SingleChoiceText: {
                selected: this.selectedAnswer(),
            }
        };
        return retVal;
    }

}
